var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavesvh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0.6875H12.5C5.975 0.6875 0.6875 5.975 0.6875 12.5V21.5C0.6875 28.025 5.975 33.3125 12.5 33.3125H21.5C28.025 33.3125 33.3125 28.025 33.3125 21.5V12.5C33.3125 5.975 28.025 0.6875 21.5 0.6875ZM27.6875 16.2125L23.975 19.8125C23.8063 19.9813 23.75 20.2062 23.75 20.4312L24.65 25.4937C24.7625 26 24.5938 26.5625 24.2563 26.9563C23.9188 27.4062 23.4125 27.6313 22.85 27.6313C22.5688 27.6313 22.2875 27.575 22.0063 27.4062L17.3938 24.9875C17.1688 24.875 16.9438 24.875 16.7188 24.9875L12.1062 27.4062C11.3187 27.8 10.3625 27.6313 9.85625 26.9563C9.51875 26.5625 9.35 26 9.4625 25.4937L10.3625 20.4312C10.4188 20.2062 10.3062 19.9813 10.1375 19.8125L6.3125 16.2125C5.80625 15.7063 5.6375 15.0312 5.8625 14.3562C6.0875 13.6812 6.65 13.175 7.38125 13.1188L12.5563 12.3875C12.7812 12.3312 13.0063 12.2188 13.1188 11.9938L15.425 7.38125C15.7625 6.7625 16.3812 6.36875 17.0562 6.36875C17.7312 6.36875 18.4062 6.7625 18.6875 7.38125L20.9937 11.9938C21.1062 12.2188 21.275 12.3312 21.5562 12.3875L26.7312 13.1188C27.4062 13.2312 28.025 13.6812 28.25 14.3562C28.3625 15.0312 28.1938 15.7625 27.6875 16.2125Z",
    fill: "#205FB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavesvh);
export default __webpack_public_path__ + "static/media/savesvh.688252d18a47f35f56f7879cfe927e2f.svg";
export { ForwardRef as ReactComponent };